import React, { useState } from 'react';
import {
  TextField, Button, Grid, Typography, RadioGroup, FormControlLabel,
  Radio, FormControl, FormLabel, FormHelperText, Box, Checkbox
} from '@mui/material';
import PdfModalViewer from './PdfModalViewer';
import { useValidatedDetailChange } from './common/useValidatedDetailChange';
import { intValidator, decimalValidator } from './common/validators';
const Comp2Sub = ({formData , setSubmitErrors, setFormData, mypageData, sameAsExhibitor, setSameAsExhibitor, fieldsDisabled, setFieldsDisabled, submitErrors, corrections, changeModalOpen, handleCorrectionChange, detailErrors, setDetailErrors,otherMethod,handleOtherMethodChange,handleMethodChange}) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
        // 出展者情報コピー
        setFormData((prev) => ({
        ...prev,
        user_2_name: mypageData.user_name || "",
        user_2_department: mypageData.department || "",
        user_2_phone: mypageData.phone_number || "",
        user_2_tel: mypageData.tel_number || "",
        }));
        setFieldsDisabled(true);
    } else if (value === "different") {
        // フィールドを空にする
        setFormData((prev) => ({
        ...prev,
        user_2_name: "",
        user_2_department: "",
        user_2_phone: "",
        user_2_tel: "",
        }));
        setFieldsDisabled(false);
    }
  };

    const handleDetailChange = useValidatedDetailChange(
    setFormData,
    setDetailErrors
    );

    const addDetail = () => {
        const newDetails = [
            ...formData.details,
            { exhibition: '', number: 0, weight: 0, length: 0, width: 0, height: 0 },
        ];
        setFormData({ ...formData, details: newDetails });
        setDetailErrors((prev) => [
            ...prev,
            { number: "", weight: "", length: "", width: "", height: "" },
        ]);
    };

    const removeDetail = (index) => {
        const newDetails = formData.details.filter((_, i) => i !== index);
        setFormData({ ...formData, details: newDetails });
    };

  const [open , setOpen] = useState(false);
  return (
    <Box sx={{ p:{xs: 0, md: 2} }}>
        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].user_2_info}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                onChange={handleCorrectionChange('r2', 'user_2_info')}
            />
            }
            label="担当者情報"
        />
        )}
        <Typography variant="h6" gutterBottom className='f-16'>担当者情報</Typography>
        <Typography color="error" className='info'>※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
        <FormControl component="fieldset" sx={{ mt: 2 }}>
            <FormLabel component="legend" className='info'>出展申込時の担当者と</FormLabel>
            <RadioGroup
            row
            value={sameAsExhibitor}
            onChange={(e) => handleSameAsExhibitor(e.target.value)}
            >
            <FormControlLabel value="same" control={<Radio />} label="同じ" />
            <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
        </FormControl>
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" name="user_2_name" value={formData.user_2_name} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_name} helperText={submitErrors.user_2_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" name="user_2_department" value={formData.user_2_department} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_department} helperText={submitErrors.user_2_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" name="user_2_phone" value={formData.user_2_phone} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_phone} helperText={submitErrors.user_2_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" name="user_2_tel" value={formData.user_2_tel} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors.user_2_tel} helperText={submitErrors.user_2_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
        </Grid>
        <Typography color="error" className='info'>※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

        <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>搬入・搬出方法</Typography>
        <Typography color="error" className='info'>現在予定している搬入・搬出方法を出展の手引きp.9～p.15を参照にご選択ください。</Typography>
        <Box>
            <Button variant="outlined" onClick={() => setOpen(true)}>出展の手引き該当ページを表示する</Button>
        </Box>
        <PdfModalViewer
            filePath="/出展の手引き.pdf"
            isOpen={open}
            onClose={() => setOpen(false)}
            startPage={10}
            endPage={17}
        />
        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].method}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                onChange={handleCorrectionChange('r2', 'method')}
            />
            }
            label="搬入出方法選択"
        />
        )}
        <Grid container spacing={2}>
            {/* 方法選択（ラジオ） */}
            <Grid size={12}>
            <FormControl fullWidth error={!!submitErrors.method}>
                <RadioGroup
                name="method"
                value={
                    formData.method.startsWith('その他｜')
                    ? 'その他'
                    : formData.method
                }
                onChange={handleMethodChange}
                >
                <FormControlLabel value="運送会社活用パターン" control={<Radio />} label="運送会社活用パターン" />
                <FormControlLabel value="周辺駐車場活用パターン" control={<Radio />} label="周辺駐車場活用パターン" />
                <FormControlLabel value="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン" control={<Radio />} label="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン" />
                <FormControlLabel value="その他" control={<Radio />} label="その他" />
                </RadioGroup>
                {formData.method === 'その他' || formData.method.startsWith('その他｜') ? (
                <TextField
                    fullWidth
                    label="その他内容"
                    value={otherMethod}
                    onChange={handleOtherMethodChange}
                    margin="normal"
                    error={!!submitErrors.otherMethod}
                    helperText={submitErrors.otherMethod}
                />
                ) : null}
                {submitErrors.method && <FormHelperText sx={{color:'#f10a0a', fontWeight: 'bold'}}>{submitErrors.method}</FormHelperText>}
            </FormControl>
            </Grid>
            <Typography color='error' className='info'>
                【注意】<br />
                ※展示館内及び展示館ローディングヤードへの車両乗り入れが必要な場合を除き、原則、運送会社・周辺駐車場をご活用ください。<br />
                ※展示館内及び展示館ローディングヤード乗入れが必要な場合、周辺の乗入れ場所に限りがあるため、展示館周辺に来るまでにかなりの混雑が想定されます。予めご了承ください。
            </Typography>

            {!!changeModalOpen &&(
            <FormControlLabel
                control={
                <Checkbox
                    checked={corrections.r2[0].date}
                    onChange={handleCorrectionChange('r2', 'date')}
                    sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                />
                }
                label="搬入出予定日"
            />
            )}

            {/* 搬入希望日選択（ラジオ） */}
            <Grid size={12}>
            <FormControl error={!!submitErrors.reserve_date}>
            <Typography variant="h6" className='f-16'>搬入予定日</Typography>

            <RadioGroup
                name="reserve_date"
                value={formData.reserve_date}
                onChange={(e) =>
                setFormData({
                    ...formData,
                    reserve_date: e.target.value,
                    // 11/3 or 11/4選んだらother_detail消す
                    other_detail:
                    e.target.value === "other" ? formData.other_detail : "",
                })
                }
                row
            >
                <FormControlLabel
                value="11/9"
                control={<Radio />}
                label="11月9日（月）"
                />

                <FormControlLabel
                value="11/10"
                control={<Radio />}
                label="11月10日（火）"
                />

                <FormControlLabel
                value="other"
                control={<Radio />}
                label="その他"
                />
            </RadioGroup>

            {/* 🔥 その他選択時だけ表示 */}
            {formData.reserve_date === "other" && (
                <TextField
                fullWidth
                margin="normal"
                label="詳細を入力してください"
                value={formData.reserve_detail}
                onChange={(e) =>
                    setFormData({
                    ...formData,
                    reserve_detail: e.target.value,
                    })
                }
                />
            )}

            {submitErrors.reserve_date && (
                <FormHelperText>{submitErrors.reserve_date}</FormHelperText>
            )}
            </FormControl>
            </Grid>
            </Grid>

        {!!changeModalOpen &&(
        <FormControlLabel
            control={
            <Checkbox
                checked={corrections.r2[0].cars}
                onChange={handleCorrectionChange('r2', 'cars')}
                sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
            />
            }
            label="車両乗り入れ"
        />
        )}

        <Grid container spacing={2}>
            <Grid size={12}>
            <FormControl error={!!submitErrors.indoor_car}>
                <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>展示館内への車両乗り入れ</Typography>
                <RadioGroup
                    row
                    name="indoor_car"
                    value={formData.indoor_car ? 'true' : 'false'}
                    onChange={(e) => {
                        const value = e.target.value === 'true';
                        if (!value) {
                        // false のとき関連項目をリセット
                        setFormData({
                            ...formData,
                            indoor_car: false,
                            mini_num: null,
                            norm_num: null,
                            big_num: null,
                            trail_num: null,
                            crain_num: null,
                            fork_num: null,
                            other_num: null,
                            other_detail: "",
                            details: [
                            {
                                exhibition: "",
                                number: null,
                                weight: null,
                                length: null,
                                width: null,
                                height: null,
                            },
                            ],
                        });
                        } else {
                        setFormData({ ...formData, indoor_car: true });
                        }
                    }}
                >
                <FormControlLabel value="true" control={<Radio />} label="する" />
                <FormControlLabel value="false" control={<Radio />} label="しない" />
                </RadioGroup>
                {submitErrors.indoor_car && <FormHelperText>{submitErrors.indoor_car}</FormHelperText>}
            </FormControl>
            </Grid>
        </Grid>

        <Grid container spacing={2}>
        {formData.indoor_car && (
        <>
            {!!changeModalOpen &&(
            <FormControlLabel
                control={
                <Checkbox
                    checked={corrections.r2[0].numbers}
                    onChange={handleCorrectionChange('r2', 'numbers')}
                    sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                />
                }
                label="車両台数"
            />
            )}
            <Typography color="error" className='info'>
            ※展示館内へ乗入れる車両台数をご入力ください。(半角整数で入力)
            </Typography>
            {[
            { label: "小型車（2tクラス以下）", name: "mini_num" },
            { label: "中型車（4tクラス以下）", name: "norm_num" },
            { label: "大型車（10tクラス以下）", name: "big_num" },
            { label: "トレーラー（コンテナを含む）", name: "trail_num" },
            { label: "クレーン", name: "crain_num" },
            { label: "フォークリフト", name: "fork_num" },
            { label: "その他台数", name: "other_num" },
            ].map(({ label, name }) => (
            <Grid size={{ xs: 12, sm: 6 }} key={name}>
                <TextField
                fullWidth
                label={label}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                error={!!(submitErrors.vehicles && name !== "other_detail")} // vehiclesエラーを表示
                helperText={name === "other_num" && submitErrors.other_detail ? submitErrors.other_detail : ""}
                />
            </Grid>
            ))}
        </>
        )}
        </Grid>
        
        {formData.indoor_car && (
            <>
            {!!changeModalOpen &&(
            <FormControlLabel
                control={
                <Checkbox
                    checked={corrections.r2[0].exhibits}
                    onChange={handleCorrectionChange('r2', 'exhibits')}
                    sx={{
          color: 'red', // 未チェック時の枠の色
          '&.Mui-checked': {
            color: 'red', // チェック時の色
          },
        }}
                />
                }
                label="出展物"
            />
            )}
            <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>出展物の詳細</Typography>
            <Typography color='error' className='info'>主な出展物のおおよそ重量・寸法をご入力ください。<br />※2つ目以降の出展物を入力される場合は「出展物を追加」をご選択ください。</Typography>
            {formData?.details?.map((detail, index) => (
            <Grid key={index} sx={{ mb: 2, pl: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                        fullWidth
                        label="展示物名"
                        value={detail.exhibition}
                        onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => {
                            const details = [...prev.details];
                            details[index] = {
                            ...details[index],
                            exhibition: value,
                            };
                            return { ...prev, details };
                        });
                        }}
                        error={!!submitErrors.details}
                        helperText={index === 0 && submitErrors.details ? submitErrors.details : ""}
                    />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3 }}>
                    <TextField
                        fullWidth
                        label="個数"
                        value={detail.number}
                        onChange={handleDetailChange(
                        index,
                        "number",
                        intValidator({ allowMinus: false, label: "個数" })
                        )}
                        error={!!detailErrors[index]?.number || !!submitErrors.details}
                        helperText={
                        detailErrors[index]?.number ||
                        (index === 0 ? submitErrors.details : "")
                        }
                    />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3 }}>
                    <TextField
                        fullWidth
                        label="重量(kg)"
                        value={detail.weight}
                        onChange={handleDetailChange(
                        index,
                        "weight",
                        decimalValidator({ scale: 2, label: "重量" })
                        )}
                        error={!!detailErrors[index]?.weight || !!submitErrors.details}
                        helperText={
                        detailErrors[index]?.weight ||
                        (index === 0 ? submitErrors.details : "")
                        }
                    />
                    </Grid>
                </Grid>

                {/* 下段 */}
                <Grid container spacing={2} sx={{ mt: 1 }} alignItems="center">
                    <Grid size={{ xs: 12, sm: 3 }}>
                    <TextField
                        fullWidth
                        label="長(mm)"
                        value={detail.length}
                        onChange={handleDetailChange(
                        index,
                        "length",
                        decimalValidator({ scale: 2, label: "長さ" })
                        )}
                        error={!!detailErrors[index]?.length}
                        helperText={detailErrors[index]?.length}
                    />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3 }}>
                    <TextField
                        fullWidth
                        label="幅(mm)"
                        value={detail.width}
                        onChange={handleDetailChange(
                        index,
                        "width",
                        decimalValidator({ scale: 2, label: "幅" })
                        )}
                        error={!!detailErrors[index]?.width}
                        helperText={detailErrors[index]?.width}
                    />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 3 }}>
                    <TextField
                        fullWidth
                        label="高さ(mm)"
                        value={detail.height}
                        onChange={handleDetailChange(
                        index,
                        "height",
                        decimalValidator({ scale: 2, label: "高さ" })
                        )}
                        error={!!detailErrors[index]?.height}
                        helperText={detailErrors[index]?.height}
                    />
                    </Grid>

                    {/* 削除ボタン */}
                    <Grid size={{ xs: 12, sm: 3 }} sx={{ textAlign: "right" }}>
                    {formData?.details?.length >= 1 && (
                        <Button
                        variant="outlined"
                        color="error"
                        onClick={() => removeDetail(index)}
                        >
                        削除
                        </Button>
                    )}
                    </Grid>
                </Grid>

                </Grid>
            ))}
            <Button variant="contained" onClick={addDetail}>出展物を追加</Button>
            </>
        )}

        <Typography variant="h6" sx={{ mt: 4 }} className='f-16'>備考欄</Typography>
        <Typography color="error" className='info'>※搬入・搬出について補足事項等がある場合はコチラにご入力ください。</Typography>
        <TextField
            fullWidth
            multiline
            rows={4}
            label="備考"
            name="alfa_text"
            value={formData.alfa_text}
            onChange={handleChange}
        />
    </Box>
  );
};

export default Comp2Sub;